export default __webpack_public_path__ + "static/media/search-solid.38ff9361.svg";